import { composeWithDevTools } from '@redux-devtools/extension';
import { makeEpicMiddleware } from 'epic';
import type { Middleware } from 'redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootEpic from 'shared/epics/rootEpic';
import * as selectors from 'state/selectors';
import type { ExtraArgument } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { catchMiddleware } from 'utils/redux/catchMiddleware';
import { logActionsMiddleware } from 'utils/redux/logActionsMiddleware';

import { rootReducer } from './rootReducer';

export function bootstrapStore(extraArguments: Omit<ExtraArgument, 'selectors'>) {
  const { enhancers, epicMiddleware } = storeConfiguration(extraArguments);
  const compose = composeWithDevTools({ trace: window?.sgmeConfiguration?.enableReduxDevToolTrace });
  const store = createStore(rootReducer, compose(enhancers));
  epicMiddleware.run(rootEpic());

  return store;
}

export const storeConfiguration = (
  extraArguments: Omit<ExtraArgument, 'selectors'>,
  ...middlewares: Middleware<ExtraArgument, AppState, any>[]
) => {
  const extraArgument: ExtraArgument = {
    ...extraArguments,
    selectors,
  };

  const epicMiddleware = makeEpicMiddleware(extraArgument);

  const enhancers = applyMiddleware(
    catchMiddleware(extraArgument.frontLogger),
    thunk.withExtraArgument(extraArgument),
    epicMiddleware,
    logActionsMiddleware(extraArgument.frontLogger),
    ...middlewares,
  );
  return { extraArgument, epicMiddleware, enhancers };
};
